import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/auth/LoginView.vue'
import AccountListView from '../views/account/AccountListView.vue'

// 商品管理
import ProductListView from '../views/products/ProductListView.vue'
import ProductRegisterView from '../views/products/ProductRegisterView.vue'
import ProductBarcodeView from '../views/products/ProductBarcodeView.vue'
import ManufacturerView from '../views/products/ManufacturerView.vue'

// 価格操作管理
import PriceIncreaseListView from '../views/price/PriceIncreaseListView.vue'
import PriceDecreaseListView from '../views/price/PriceDecreaseListView.vue'

// 店舗移動管理
import StoreTransferListView from '../views/store/StoreTransferListView.vue'
import StoreTransferRegisterView from '../views/store/StoreTransferRegisterView.vue'
import StoreTransferShippingView from '../views/store/StoreTransferShippingView.vue'
import StoreTransferArrivalView from '../views/store/StoreTransferArrivalView.vue'

// 買取査定管理
import PurchaseRegisterView from '../views/purchase/PurchaseRegisterView.vue'
import PurchaseDataRegisterView from '../views/purchase/PurchaseDataRegisterView.vue'
import PurchaseHistoryView from '../views/purchase/PurchaseHistoryView.vue'
import PurchaseDetailView from '../views/purchase/PurchaseDetailView.vue'

// 棚卸管理
import InventoryListView from '../views/inventory/InventoryListView.vue'
import InventoryStartRegisterView from '../views/inventory/InventoryStartRegisterView.vue'
import InventoryCategoryView from '../views/inventory/InventoryCategoryView.vue'
import InventoryImplementationView from '../views/inventory/InventoryImplementationView.vue'

// 売上管理
import SalesManagementView from '../views/sales/SalesManagementView.vue'

// イベントログ
import EventLogListView from '../views/logs/EventLogList.vue'

// 開発者向け機能
import ExternalShopsTestView from '../views/development/ExternalShopsTestView.vue'
import DatabaseBackupView from '../views/development/DatabaseBackup.vue'
import constants from '../constants/constants.json'
const { Authority } = constants

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  // アカウント管理
  {
    path: '/accounts',
    name: 'AccountList',
    component: AccountListView
  },
  // 商品管理
  {
    path: '/products',
    name: 'ProductList',
    component: ProductListView
  },
  {
    path: '/products/register',
    name: 'ProductRegister',
    component: ProductRegisterView
  },
  {
    path: '/products/register/:id',
    name: 'ProductEdit',
    component: ProductRegisterView
  },
  {
    path: '/products/barcode',
    name: 'ProductBarcode',
    component: ProductBarcodeView
  },
  {
    path: '/products/manufacturers',
    name: 'Manufacturers',
    component: ManufacturerView
  },
  // 価格操作管理
  {
    path: '/price/increase',
    name: 'PriceIncreaseList',
    component: PriceIncreaseListView
  },
  {
    path: '/price/decrease',
    name: 'PriceDecreaseList',
    component: PriceDecreaseListView
  },
  // 店舗移動管理
  {
    path: '/store/transfer',
    name: 'StoreTransferList',
    component: StoreTransferListView
  },
  {
    path: '/store/transfer/register',
    name: 'StoreTransferRegister',
    component: StoreTransferRegisterView
  },
  {
    path: '/store/transfer/shipping',
    name: 'StoreTransferShipping',
    component: StoreTransferShippingView
  },
  {
    path: '/store/transfer/arrival',
    name: 'StoreTransferArrival',
    component: StoreTransferArrivalView
  },
  // 買取査定管理
  {
    path: '/purchase/register/:id?',
    name: 'PurchaseRegister',
    component: PurchaseRegisterView,
    props: true
  },
  {
    path: '/purchase/data/register/:id?',
    name: 'PurchaseDataRegister',
    component: PurchaseDataRegisterView,
    props: true
  },
  {
    path: '/purchase/history',
    name: 'PurchaseHistory',
    component: PurchaseHistoryView
  },
  {
    path: '/purchase/detail/:id',
    name: 'PurchaseDetailView',
    component: PurchaseDetailView,
    props: true
  },
  // 棚卸管理
  {
    path: '/inventory',
    name: 'InventoryList',
    component: InventoryListView
  },
  {
    path: '/inventory/start/register',
    name: 'InventoryStartRegister',
    component: InventoryStartRegisterView
  },
  {
    path: '/inventory/category',
    name: 'InventoryCategory',
    component: InventoryCategoryView
  },
  {
    path: '/inventory/implementation',
    name: 'InventoryImplementation',
    component: InventoryImplementationView
  },
  // 売上管理
  {
    path: '/sales',
    name: 'SalesManagement',
    component: SalesManagementView
  },
  // ログ管理
  {
    path: '/logs/event',
    name: 'EventLogList',
    component: EventLogListView
  },
  // 開発者向け機能
  // 外部ショップとの連携テスト
  {
    path: '/dev/shops',
    name: 'ExternalShopsTest',
    component: ExternalShopsTestView,
    meta: {
      requiresAdmin: true
    }
  },
  // 開発者向け機能
  // Databaseバックアップとリストア
  {
    path: '/dev/database',
    name: 'DatabaseBackup',
    component: DatabaseBackupView,
    meta: {
      requiresAdmin: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    localStorage.removeItem('user');
    localStorage.removeItem('expiresAt');
    localStorage.removeItem('accountName');
    localStorage.removeItem('token');
    next();
    return;
  }

  const userStr = localStorage.getItem('user');
  const expiresAt = localStorage.getItem('expiresAt');

  if (!userStr || !expiresAt) {
    next('/');
    return;
  }

  const now = new Date().getTime();
  if (parseInt(expiresAt) <= now) {
    localStorage.removeItem('user');
    localStorage.removeItem('expiresAt');
    localStorage.removeItem('accountName');
    next('/');
    return;
  }

  const user = JSON.parse(userStr);
  if (to.meta.requiresAdmin && user.authority !== Authority.ADMIN.id) {
    next('/');
    return;
  }

  next();
});

export default router
